import { all, fork } from "redux-saga/effects";
import remittanceSaga from "../pages/remittance-beta/state/remittanceSaga";
import historySaga from "../pages/history/state/historySaga";

export default function* rootSaga() {
  yield all([fork(remittanceSaga), fork(historySaga)]);
}
